/* src/app/admin/ticket-reassign/ticket-reassign.component.scss */
.reassign-preview {
  border: 1px solid #dee2e6;
}
.reassign-counts {
  max-width: 320px;
}
.reassign-hint {
  display: block;
  margin-top: 4px;
  font-size: 13px;
  color: #6c757d;
}
.reassign-reason {
  min-width: 160px;
  max-width: 280px;
  white-space: pre-line;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.reassign-reason-meter {
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
  font-size: 13px;
  color: #6c757d;
}
.reassign-reason-meter.reassign-reason-ok {
  color: #1e7e34;
}
.reassign-reason-meter i {
  margin-right: 4px;
}
.reassign-date {
  white-space: nowrap;
}
.reassign-state {
  min-width: 150px;
}
.reassign-sub {
  display: block;
  font-size: 12px;
  color: #6c757d;
  overflow-wrap: anywhere;
}
.reassign-person {
  max-width: 190px;
}
.reassign-table-wrap {
  overflow-x: auto;
}
.reassign-history {
  margin-bottom: 0;
}
.reassign-history th,
.reassign-history td {
  vertical-align: top;
}
.reassign-filter {
  height: 34px;
  padding: 4px 8px;
  font-size: 13px;
  border: 1px solid #ced4da;
}
.reassign-history-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: space-between;
  align-items: center;
  min-height: 31px;
  font-size: 14px;
}
.reassign-top-pager {
  margin-left: auto;
}
.reassign-top-pager .pagination {
  margin: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.reassign-top-pager + .reassign-history-actions {
  margin-left: 0;
}
@media (max-width: 1199.98px) {
  .reassign-top-pager {
    order: 3;
    flex-basis: 100%;
    display: flex;
    justify-content: flex-end;
  }
  .reassign-top-pager + .reassign-history-actions {
    margin-left: auto;
  }
}
.reassign-history-actions {
  display: flex;
  gap: 8px;
  margin-left: auto;
}
.reassign-export-hint {
  text-align: right;
}
.reassign-picker-links {
  display: flex;
  gap: 16px;
  margin: 4px 0;
  font-size: 13px;
}
.reassign-picker-links .btn-link {
  font-size: 13px;
  line-height: 1.5;
  vertical-align: baseline;
}
.reassign-picker {
  max-height: 300px;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 6px 8px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background:
    linear-gradient(#fff 30%, rgba(255, 255, 255, 0)) top/100% 24px no-repeat local,
    linear-gradient(rgba(255, 255, 255, 0), #fff 70%) bottom/100% 24px no-repeat local,
    linear-gradient(rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0)) top/100% 10px no-repeat scroll,
    linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.14)) bottom/100% 10px no-repeat scroll,
    #fff;
  scrollbar-width: thin;
  scrollbar-color: #9aa0a6 #f1f3f4;
}
.reassign-picker::-webkit-scrollbar {
  width: 10px;
}
.reassign-picker::-webkit-scrollbar-track {
  background: #f1f3f4;
  border-radius: 0 4px 4px 0;
}
.reassign-picker::-webkit-scrollbar-thumb {
  background: #9aa0a6;
  border-radius: 5px;
  border: 2px solid #f1f3f4;
}
.reassign-picker-count {
  margin-left: auto;
  color: #6c757d;
}
.reassign-attention-heading {
  font-family: halbfett, sans-serif;
  font-size: 19px;
  font-weight: normal;
  color: #80163a;
}
.reassign-picker-row {
  padding-top: 2px;
  padding-bottom: 2px;
}
.reassign-picker-row .form-check-label {
  font-size: 13px;
  overflow-wrap: anywhere;
  cursor: pointer;
}
.reassign-picker-group {
  margin-top: 8px;
  padding-top: 6px;
  border-top: 1px solid #e9ecef;
}
.reassign-picker-heading {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
}
.reassign-preview-sources {
  margin-bottom: 0;
}
.reassign-preview-sources th,
.reassign-preview-sources td {
  vertical-align: top;
}
.reassign-preview-total td {
  border-top: 2px solid #dee2e6;
}
.reassign-muted {
  color: #6c757d;
}
.reassign-attention-block + .reassign-attention-block {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e9ecef;
}
.reassign-attention-title {
  margin-bottom: 4px;
  font-family: halbfett, sans-serif;
  font-weight: normal;
}
.reassign-attention-causes {
  max-width: 360px;
  margin-bottom: 0;
}
.reassign-attention-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
/*# sourceMappingURL=ticket-reassign.component-BWJQQB37.css.map */
